<template>
  <div
    class="m-header"
    v-if="extraItem.extras('nav.display')"
    :style="{
      height: pxOrVw(extraItem.extras('nav.model')),
    }"
  >
    <div class="header-inner">
      <a
        v-if="extraItem.extras('logo.display')"
        class="logo"
        :href="
          extraItem.extras('logo.href')
            ? extraItem.extras('logo.href')
            : 'javascript:;'
        "
        :style="{
          cursor: extraItem.extras('logo.href') ? 'pointer' : 'default',
        }"
        :class="extraItem.extras('logo.size')"
      >
        <img :src="extraItem.extras('logo.src')" alt="" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: ["extras"],
  methods: {
    logoClick() {
      if (
        this.extras.logo.href &&
        RegExp("^https?:\\/\\/.+").test(this.extras.logo.href)
      ) {
        window.$sk.goto(this.extras.logo.href);
      }
    },
  },
};
</script>
